/* eslint-disable eqeqeq */

import {
    Box,

    InputLabel,
    OutlinedInput,

    Radio,
    Typography,
} from "@mui/material";
import React from "react";
import * as PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
export default function RecipientEntityForm({ ownership,
    setOwnership, setRecipientEntity,
    recipientFirstName, handleNameChange,
    recipientEntity, handleOwnershipChange,
    isAddressSomeoneElse,
    recipientLastName,
loading }) {
    const { t } = useTranslation();

    return <Box marginTop={2}>
        <Typography
            fontSize={14}
            fontWeight={700}
            fontFamily={"Manrope"}
            textTransform={"capitalize"}
        >
            {t("transfer.confirmWalletAddressOwnership")}
        </Typography>

        <Box
            display={"flex"}
            flexDirection={"column"}

        >
            <InputLabel
                sx={{
                    display: "flex",
                    cursor: "pointer",
                                margin: "0",
                    alignItems: "center"
                }}
            >
                {/* {ownership} */}
                <Radio
                    name="ownership"
                    value="0"
                    checked={ownership === "0"}
                    disabled={loading}

                    onChange={() => handleOwnershipChange("0")}
                    sx={{
                        '&:after': {
                            borderBottom: 'none'
                        },
                        cursor: "pointer"
                    }}
                />
                &nbsp; {t("transfer.confirmWallet.belongsToMe")}</InputLabel>
            <InputLabel
                sx={{
                    display: "flex",
                    margin: "0",
                    cursor: "pointer",
                    alignItems: "center"
                }}
            >
                <Radio
                    name="ownership"
                    value="1"
                    checked={ownership === "1"}
                    disabled={loading}
                    onChange={() =>setOwnership("1")}
                    sx={{
                        '&:after': {
                            borderBottom: 'none'
                        },
                        cursor: "pointer"
                    }}
                />
                &nbsp; {t("transfer.confirmWallet.belongsToSomeoneElse")}
            </InputLabel>
        </Box>
        {isAddressSomeoneElse && <Box sx={{ marginTop: '10px' }}>
            <Box
                borderRadius={2}
            >
                <Typography
                    fontSize={14}

                    fontFamily={"Manrope"}
                    textTransform={"capitalize"}
                    fontWeight='bold'
                >
                    {t("recipientEntity")}
                </Typography>
                <Box
                    display={"flex"}
                    gap={3}
                >

                    <InputLabel
                        sx={{
                            display: "flex",
                            cursor: "pointer",
                            alignItems: "center",
                        }}
                    >
                        <Radio
                            name="recipientEntity"
                            value="0"
                            checked={recipientEntity === "0"}
                            onChange={() => setRecipientEntity("0")}
                    disabled={loading}

                            color="primary"
                            opacity="1"
                            sx={{
                                '&:after': {
                                    borderBottom: 'none'
                                },
                                cursor: "pointer",
                            }}
                        />
                        &nbsp; {t("individual")}
                    </InputLabel>
                    <InputLabel
                        sx={{
                            display: "flex",
                            cursor: "pointer",
                            alignItems: "center"
                        }}
                    >
                        <Radio
                            name="recipientEntity"
                            value="1"
                            checked={recipientEntity === "1"}
                            onChange={() => setRecipientEntity("1")}
                    disabled={loading}

                            sx={{
                                '&:after': {
                                    borderBottom: 'none'
                                },
                                cursor: "pointer"
                            }}
                        />
                        &nbsp; {t("company")}
                    </InputLabel>
                </Box>
                <Box
                    display={"flex"}
                    gap={3}
                    justifyContent={"space-between"}
                >
                    <InputLabel
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            fontWeight: 'bold',
                            overflow: 'inherit'
                        }}
                    >
                        {t("transfer.recipientfirstName")}
                        &nbsp;
                        <OutlinedInput
                            name="recipientFirstName"
                            value={recipientFirstName}
                            type="text"
                    disabled={loading}

                            autoComplete="off"
                            sx={{
                                height: '39px',
                                backgroundColor: "transparent",
                                border: "1px solid #fff",
                                marginTop: "10px",
                                fontSize: "16px",
                                padding: '0',
                                '& input': {
                                    padding: '8px'
                                }

                            }}
                            onChange={handleNameChange}
                        />
                    </InputLabel>
                    <InputLabel
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            fontWeight: 'bold',
                            overflow: 'inherit',

                        }}
                    >
                        {t("transfer.recipientlastName")}
                        &nbsp;
                        <OutlinedInput
                            name="recipientLastName"
                            value={recipientLastName}
                            autoComplete="off"
                            type="text"
                            onChange={handleNameChange}
                            disabled={loading}
                            sx={{
                                height: '39px',
                                padding: '0',
                                fontSize: "16px",
                                marginTop: "10px",
                                backgroundColor: "transparent",
                                border: "1px solid #fff",
                                '& input': {
                                    padding: '8px'
                                }
                            }}
                        />
                    </InputLabel>
                </Box>
            </Box>
        </Box>}
    </Box>
}
RecipientEntityForm.propTypes = {
    ownership: PropTypes.string,
    setOwnership: PropTypes.func,
    loading: PropTypes.bool,
    setRecipientEntity: PropTypes.func,
    recipientFirstName: PropTypes.string,
    recipientLastName: PropTypes.string,
    handleNameChange: PropTypes.func,
    recipientEntity: PropTypes.string,
    handleOwnershipChange: PropTypes.func,
    isAddressSomeoneElse: PropTypes.bool
};